import { CommonUtility, regex } from "utility";

const nftValidate = (values: any) => {
    const errors: any = {};

    if (!values.name.trim()) {
        errors.name = ' Name is required'
    }
    if (!values.image.trim()) {
        errors.image = 'Image is required'
    }
    if(values.externalLink.trim() && !CommonUtility.validatePattern(regex.URL, values?.externalLink)){
        errors.externalLink= 'invalid url'
    }
    if (!values.networkId) {
        errors.networkId = 'Network is required'
    }
    if (!values.ownerAddress.trim()) {
        errors.ownerAddress = 'Owner address is required'
    }
    else if (!CommonUtility.validatePattern(regex.CONTRACT_ADDRESS, values.ownerAddress)) {
        errors.ownerAddress = 'Owner address is required'
    }
    return errors;
}

const credentialsValidate = (values: any) => {
    const errors: any = {};

    if (!values.username.trim()) {
        errors.username = 'Username is required'
    }
    if (!values.password.trim()) {
        errors.password = 'Password is required'
    }
    return errors;
}

const updateUsernameValidate = (values: any) => {
    const errors: any = {};

    if (!values.username.trim()) {
        errors.username = 'Username is required'
    }
    return errors;
}

const updatePasswordValidate = (values: any) => {
    const errors: any = {};

    if (!values.current_password.trim()) {
        errors.current_password = 'Current password is required'
    }
    if (!values.new_password.trim()) {
        errors.new_password = 'New password is required'
    }
    if (!values.confirm_password.trim()) {
        errors.confirm_password = 'Confirm password is required'
    }
    else if (values.new_password != values.confirm_password) {
        errors.confirm_password = 'Password not matched'
    }

    return errors;
}

const collectionValidate = (values: any) => {
    const errors: any = {};

    if (!values.name.trim()) {
        errors.name = ' Name is required'
    }
    if (!values.logo) {
        errors.logo = 'Logo is required'
    }
    if (!values.description.trim()) {
        errors.description = 'Description Address is required'
    }
    if (!values.category.trim()) {
        errors.category = 'Category Address is required'
    }
    if (!values.featuredImage) {
        errors.featuredImage = 'Featured image is required'
    }
    if (!values.network) {
        errors.network = 'Network is required'
    }
    if (!values.paymentToken.trim()) {
        errors.paymentToken = 'Payment token is required'
    }
    if (!values.bannerImage) {
        errors.bannerImage = 'Banner image is required'
    }
    return errors;
}

const categoryValidate = (values: any) => {
    const errors: any = {};

    if (!values.name.trim()) {
        errors.name = 'Name is required'
    }
    if (!values.instructions.trim()) {
        errors.instructions = 'Instructions is required'
    }
    return errors;
}

const sellValidate = (values: any) => {
    const errors: any = {};

    if (!values.tokenAddress.trim()) {
        errors.tokenAddress = 'Token Address is required'
    }
 
    if (!values.amount.trim()) {
        errors.amount = 'Amount is required'
    }
    else if(values.amount<0){
        errors.amount= 'Price cannot be negative'
    }
    return errors;
}

const userValidate = (values: any) => {
    const errors: any = {};

    if (!values.name.trim()) {
        errors.name = 'Name is required'
    }
 
    if (!values.email.trim()) {
        errors.email = 'Email is required'
    }
    else if(CommonUtility.validatePattern(regex.EMAIL, values.email)){
        errors.email = 'Invalid email'
    }
    if(!values.profImage.trim()){
        errors.profImage= 'Profile Image is required'
    }
    if(!values.coverImage.trim()){
        errors.coverImage= 'Cover Image is required'
    }
    if(!values.walletAddress.trim()){
        errors.walletAddress= 'wallet address is required'
    }
   else if(!CommonUtility.validatePattern(regex.CONTRACT_ADDRESS, values.walletAddress)){
        errors.walletAddress= 'Invalid wallet address'
    }
    return errors;
}

const moralisCollectionValidate = (values: any) => {
    const errors: any = {};

    if (!(values.protocol).toString()?.trim()) {
        errors.protocol = 'Select blockchain'
    }
    if(!values.address.trim()){
        errors.address= 'token address is required'
    }
   else if(!CommonUtility.validatePattern(regex.CONTRACT_ADDRESS, values.address)){
        errors.address= 'Invalid token address'
    }
    return errors;
}

const reportValidation = (values: any) => {
    const errors: any = {};

    if (!values?.title?.trim()) {
        errors.title = 'Title is required'
    }
    if(!values?.message?.trim()){
        errors.message= 'Message is required'
    }
    return errors;
}

export {
    nftValidate,
    credentialsValidate,
    updateUsernameValidate,
    userValidate,
    updatePasswordValidate,
    collectionValidate,
    categoryValidate,
    sellValidate,
    moralisCollectionValidate,
    reportValidation
}